const passwordFieldNames = {
  OLD: 'old_password',
  NEW: 'new_password',
  CONFIRM: 'confirm_password',
};

export default passwordFieldNames;
